/*
  Simply Drop: abhängige Variantenauswahl (P9.3, Motivflasche).

  Shopify kennt keine voneinander abhängigen Optionswerte. Bei der Motivflasche
  gibt es Motiv, Füllung (Badesalz oder Badepulver) und Sorte, und die Sorten
  hängen von der Füllung ab. Prestige zeigt Werte ohne passende Variante nur
  durchgestrichen und landet nach einem Füllungswechsel auf einer Kombination,
  die es nicht gibt ("Nicht verfügbar").

  Regel, generisch für jedes Produkt: Ein Wert der Option N wird ausgeblendet,
  wenn es mit den gewählten Werten der Optionen 1 bis N-1 keine Variante gibt.
  Wird eine vordere Option geändert und passt eine hintere nicht mehr, wird
  dort der Wert der ersten passenden Variante gewählt (verfügbare zuerst).

  Prestige blendet bei "Ausverkaufte ausblenden" gesperrte Werte schon selbst
  aus (:disabled + .block-swatch). Das deckt den Seitenaufbau ab. Dieses Script
  sorgt dafür, dass die Liste schon beim Klick stimmt, und für die Nachwahl.

  Einhängepunkt: snippets/sd-variant-picker.liquid. Das Snippet lädt diese Datei
  und die Variantendaten nur, wenn nicht jede Kombination existiert. Produkte mit
  vollständiger Variantenmatrix bekommen die Datei gar nicht.

  Verdrahtung mit Prestige (assets/theme.js, VariantPicker): Prestige liest bei
  "change" die angehakten Radios des Formulars und lädt die Section für diese
  Kombination. Dieser Listener läuft in der Capture-Phase auf document, also vor
  Prestige. Er setzt nur die Haken um, Prestige lädt dann direkt die gültige
  Kombination: ein Abruf, kein Seitenneuladen, kein Wettlauf. Preis, Grundpreis,
  Bild, Kaufbutton und ?variant= in der URL aktualisiert Prestige wie immer.
  Nach jedem Neuaufbau des Wählers greift der MutationObserver erneut.
*/
(function () {
  if (window.sdAbhaengigeAuswahl) return;
  window.sdAbhaengigeAuswahl = true;

  var WAEHLER = 'variant-picker[data-sd-abhaengig]';

  function daten(picker) {
    if (picker._sdAbh) return picker._sdAbh;
    var el = picker.querySelector('script[data-sd-abhaengig-daten]');
    if (!el) return null;
    var d;
    try { d = JSON.parse(el.textContent); } catch (e) { return null; }
    if (!d || !d.optionen || !d.varianten) return null;
    d.name = {};
    d.optionen.forEach(function (werte) {
      werte.forEach(function (w) { d.name[String(w[0])] = w[1]; });
    });
    picker._sdAbh = d;
    return d;
  }

  function eingaben(picker, p) {
    return [].slice.call(picker.querySelectorAll('input[data-option-position="' + (p + 1) + '"]'));
  }

  function auswahl(picker, d) {
    return d.optionen.map(function (_, p) {
      var c = picker.querySelector('input[data-option-position="' + (p + 1) + '"]:checked');
      return c ? d.name[c.value] : null;
    });
  }

  /* Gibt es eine Variante mit den gewählten Werten vor Position p und diesem Wert an p? */
  function passt(d, gewaehlt, p, wert, nurVerfuegbar) {
    return d.varianten.some(function (v) {
      if (nurVerfuegbar && !v[0]) return false;
      if (v[1][p] !== wert) return false;
      for (var q = 0; q < p; q++) {
        if (v[1][q] !== gewaehlt[q]) return false;
      }
      return true;
    });
  }

  function sichtbar(input) {
    if (!input.labels || !input.labels.length) return null;
    var l = input.labels[0];
    return l.contains(input) ? (l.closest('.popover__value-option') || l) : l;
  }

  function wertAnzeigen(picker, p, name) {
    var gruppe = picker.querySelectorAll('.variant-picker__option')[p];
    var ziel = gruppe && gruppe.querySelector('.sd-varwert');
    if (ziel) ziel.textContent = name;
  }

  /* Erste Variante in Shopify-Reihenfolge, die zu den Werten vor Position p passt (verfügbare zuerst). */
  function ersteVariante(d, gewaehlt, p) {
    function vorn(v) {
      for (var q = 0; q < p; q++) {
        if (v[1][q] !== gewaehlt[q]) return false;
      }
      return true;
    }
    return d.varianten.filter(function (v) { return v[0] && vorn(v); })[0] ||
           d.varianten.filter(vorn)[0];
  }

  /* Hintere Optionen nachwählen, falls die Auswahl nicht existiert. Maßgeblich ist die
     Variantenreihenfolge im Admin, wie beim früheren Sprung auf ?variant= und bei
     Shopifys "erste verfügbare Variante". Bei der Motivflasche ergibt das die erste Sorte. */
  function korrigieren(picker, d) {
    var gewaehlt = auswahl(picker, d);
    for (var p = 1; p < d.optionen.length; p++) {
      if (gewaehlt[p] !== null && passt(d, gewaehlt, p, gewaehlt[p], false)) continue;
      var v = ersteVariante(d, gewaehlt, p);
      if (!v) return;
      var neu = d.optionen[p].filter(function (w) { return w[1] === v[1][p]; })[0];
      if (!neu) return;
      var input = picker.querySelector('input[data-option-position="' + (p + 1) + '"][value="' + neu[0] + '"]');
      if (!input) return;
      input.disabled = false;
      input.checked = true;
      gewaehlt[p] = neu[1];
      wertAnzeigen(picker, p, neu[1]);
    }
  }

  /* Werte ohne passende Variante ausblenden, wieder gültige einblenden. */
  function anwenden(picker) {
    var d = daten(picker);
    if (!d) return;
    var gewaehlt = auswahl(picker, d);
    for (var p = 1; p < d.optionen.length; p++) {
      eingaben(picker, p).forEach(function (input) {
        var wert = d.name[input.value];
        if (wert === undefined) return;
        var el = sichtbar(input);
        if (!passt(d, gewaehlt, p, wert, false)) {
          input.disabled = true;
          input.setAttribute('data-sd-weg', '');
          if (el) { el.hidden = true; el.style.display = 'none'; }
          return;
        }
        if (input.hasAttribute('data-sd-weg')) {
          input.removeAttribute('data-sd-weg');
          if (el) { el.hidden = false; el.style.display = ''; }
        }
        /* Nur freigeben, nie zusätzlich sperren: Ausverkauftes regelt Prestige selbst. */
        if (passt(d, gewaehlt, p, wert, true)) {
          input.disabled = false;
          if (el) el.classList.remove('is-disabled');
        }
      });
    }
    picker.setAttribute('data-sd-bereit', '');
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('input[data-option-position]')) return;
    var picker = t.closest(WAEHLER);
    if (!picker) return;
    var d = daten(picker);
    if (!d) return;
    korrigieren(picker, d);
    anwenden(picker);
  }, true);

  function alle(wurzel) {
    if (wurzel.nodeType !== 1) return;
    if (wurzel.matches(WAEHLER)) anwenden(wurzel);
    [].forEach.call(wurzel.querySelectorAll(WAEHLER), anwenden);
  }

  new MutationObserver(function (liste) {
    liste.forEach(function (m) { [].forEach.call(m.addedNodes, alle); });
  }).observe(document.documentElement, { childList: true, subtree: true });

  alle(document.documentElement);
})();
